<script>
import emailjs from "emailjs-com";
import feather from "feather-icons";
import Button from "./reusable/Button.vue";
import FormInput from "./reusable/FormInput.vue";
import FormTextarea from "./reusable/FormTextarea.vue";
export default {
  props: ["showModal", "modal", "categories"],
  components: { Button, FormInput, FormTextarea },
  data() {
    return {
      category: "",
      name: "",
      email: "",
      details: "",
    };
  },
  mounted() {
    feather.replace();
  },
  updated() {
    feather.replace();
  },
  methods: {
    setEmail(value) {
      this.email = value;
    },
    setName(value) {
      this.name = value;
    },
    setDetails(value) {
      console.log(value);
      this.details = value;
    },
    async SendProjectRequest() {
      const formData = {
        full_name: this.name, // Make sure to bind the input values using v-model
        email: this.email,
        project_type: this.category,
        details: this.details,
      };
      try {
        const response = await emailjs.send(
          "service_rcei9sk",
          "template_c884r5x",
          formData,
          "ZlVfqAPy5BRVTMcnB"
        );

        console.log("Email sent:", response);
        // Handle success (e.g., show a success message)
      } catch (error) {
        console.error("Email error:", error);
        // Handle error (e.g., show an error message)
      }
      console.log(formData);
    },
  },
};
</script>

<template>
  <transition name="fade">
    <div v-show="modal" class="font-general-regular fixed inset-0 z-30">
      <!-- Modal body background as backdrop -->
      <div
        v-show="modal"
        @click="showModal()"
        class="bg-filter bg-black bg-opacity-50 fixed inset-0 w-full h-full z-20"
      ></div>
      <!-- Modal content -->
      <main class="flex flex-col items-center justify-center h-full w-full">
        <transition name="fade-up-down">
          <div v-show="modal" class="modal-wrapper flex items-center z-30">
            <div
              class="modal max-w-md mx-5 md:max-w-xl bg-secondary-light dark:bg-primary-dark max-h-screen shadow-lg flex-row rounded-lg relative"
            >
              <div
                class="modal-header flex justify-between gap-10 p-5 border-b border-ternary-light dark:border-ternary-dark"
              >
                <h5 class="text-primary-dark dark:text-primary-light text-xl">
                  What project are you looking for?
                </h5>
                <button
                  class="px-4 text-primary-dark dark:text-primary-light"
                  @click="showModal()"
                >
                  <i data-feather="x"></i>
                </button>
              </div>
              <div class="modal-body p-5 w-full h-full">
                <form class="max-w-xl m-4 text-left">
                  <FormInput
                    :value="name"
                    @update="setName"
                    label="Full Name"
                    inputIdentifier="name"
                    class="mb-2"
                  />
                  <FormInput
                    :value="email"
                    @update="setEmail"
                    label="Email"
                    inputIdentifier="email"
                    inputType="email"
                  />

                  <div class="mt-6 mb-4">
                    <label
                      class="block mb-2 text-lg text-primary-dark dark:text-primary-light"
                      for="project"
                      >Project Type</label
                    >
                    <select
                      class="w-full px-5 py-3 border-1 border-ternary-dark dark:border-secondary-dark rounded-md text-md bg-secondary-light dark:bg-white text-primary-dark dark:text-secondary-dark"
                      id="project"
                      name="project"
                      required=""
                      placeholder="Project Type"
                      aria-label="Project Category"
                      v-model="category"
                      value="front-end"
                    >
                      <option
                        v-for="category in categories"
                        :key="category.id"
                        :value="category.value"
                      >
                        {{ category.name }}
                      </option>
                    </select>
                  </div>

                  <FormTextarea
                    :value="details"
                    @update="setDetails"
                    label="Details"
                    textareaIdentifier="details"
                  />

                  <div class="modal-footer sm:mt-0 pt-3 border0-t text-right">
                    <Button
                      title="Send Request"
                      class="px-4 sm:px-6 py-2 sm:py-2.5 text-white bg-ternary-dark hover:bg-[#1A6F69] rounded-md focus:ring-1 focus:ring-indigo-900 duration-500"
                      type="submit"
                      aria-label="Submit Request"
                      @click.prevent="SendProjectRequest"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </transition>
      </main>
    </div>
  </transition>
</template>

<style scoped>
.modal-body {
  max-height: 620px;
  overflow-y: auto;
}
.bg-gray-800-opacity {
  background-color: #2d374850;
}
@media screen and (max-width: 768px) {
  .modal-body {
    max-height: 400px;
  }
}
.fade-up-down-enter-active {
  transition: all 0.3s ease;
}
.fade-up-down-leave-active {
  transition: all 0.3s ease;
}
.fade-up-down-enter {
  transform: translateY(10%);
  opacity: 0;
}
.fade-up-down-leave-to {
  transform: translateY(10%);
  opacity: 0;
}

.fade-enter-active {
  -webkit-transition: opacity 2s;
  transition: opacity 0.3s;
}
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
